export default {

    SET_SELECT_AGENT({commit},Agent){
        commit('SET_SELECT_AGENT',Agent)
    },
    SET_RESULT({commit},result){
        commit('SET_RESULT',result)
    },
    SET_EDIT_AGENT({commit},editAgent){
        commit('SET_EDIT_AGENT',editAgent)
    },
}
